import styled from 'styled-components';
import Colours from './Colours';
import Media from './Media';
import { fontFamilyRegular } from './Fonts';

export const Control = styled.div`
  margin-bottom: 1.25rem;
  position: relative;
`;

export const ControlLabel = styled.div`
  position: relative;

  label {
    display: inline-block;
    margin-bottom: 4px;
    ${fontFamilyRegular};
  }

  .input__required {
    color: ${Colours.critical};
  }
`;

export const ControlField = styled.div`
  position: relative;
`;

export const ControlError = styled.div`
  color: ${Colours.critical};
  font-size: 12px;
  margin-top: 2px;
`;

export const ControlFieldInput = styled.div<{ hasError: boolean }>`
  position: relative;

  input,
  .control__input {
    background-color: ${Colours.white};
    border: 1px solid ${Colours.lightGrey};
    border-radius: 2px;
    box-sizing: border-box;
    ${fontFamilyRegular};
    font-size: 16px;
    height: 46px;
    padding: 0 0.6rem;
    width: 100%;
    -webkit-appearance: none;
    transition: box-shadow 0.3s ease-in-out;
    text-align: left;

    &::-ms-clear {
      display: none;
    }
    &:focus {
      outline: none;
      box-shadow: 0 0 0 3px rgba(8, 132, 252, 0.3);
    }
  }

  .control__input {
    line-height: 46px;
    overflow: hidden;
    padding-right: 28px;
    white-space: nowrap;

    &--empty {
      color: ${Colours.secondaryText};
    }
  }

  ${({ hasError }) =>
    hasError &&
    `
    input,
    .control__input {
      border: 1px solid ${Colours.critical};
    }
  `}
`;

export const ControlPair = styled.div`
  @media ${Media.tablet} {
    display: flex;
    flex-direction: row;

    & > div {
      flex: 1;
    }
    & > div:first-child {
      padding-right: 0.3125rem;
    }
    & > div:last-child {
      padding-left: 0.3125rem;
    }
  }
`;

export const ControlArrow = styled.div`
  color: ${Colours.secondaryText};
  position: absolute;
  margin-top: -0.5rem;
  right: 1rem;
  top: 50%;
`;
